module.exports = __webpack_public_path__ + "img/icon-introduction-璟馨.b1fc8ace.png";